export class Produit {
    static jsonMap = {
        id: { key: 'id' },
        code: { key: 'code' },
        libelle: { key: 'libelle' },
        idCahier: { key: 'idCahier', optional: true },
        libelleCahier: { key: 'libelleCahier', optional: true },
        eligibleVci: { key: 'eligibleVCI', optional: true },
        eligibleVsi: { key: 'eligibleVSI', optional: true },
        vinBase: { key: 'vinBase', optional: true }
    };

    id: number = undefined;
    code: string = undefined;
    libelle: string = undefined;
    idCahier: number;
    libelleCahier: string;
    eligibleVci = false;
    eligibleVsi = false;
    vinBase = false;
}
